import { always, complement, equals, pipe, range } from 'rambda'
import { FACT_TYPES } from '@store/modules/fact'

const getColumnIndex = column => [...column]
  .map((_, index) =>
    (column.charCodeAt(index) - 64) * Math.pow(26, column.length - index - 1))
  .reduce((sum, charIndex) => sum + charIndex, -1)

export const column = (column) => {
  const index = getColumnIndex(column)

  return row => row[index]
}

export const columnNumber = columnLetter => pipe(
  column(columnLetter),
  Number,
)

export const columnBoolean = columnLetter => pipe(
  column(columnLetter),
  value => value === 'true' || value === 'TRUE',
)

export const columnJsonObject = columnLetter => pipe(
  column(columnLetter),
  value => typeof value === 'string' && value.length
    ? JSON.parse(value)
    : {},
)

export const columnEveryNth = (everyNth, limit, columnLetter) => {
  const indexInitial = getColumnIndex(columnLetter)
  const indexes = range(0, limit)
    .map(index => indexInitial + index * everyNth)

  return row => indexes.map(index => row[index])
}

export const factsToGenerate = always([
  FACT_TYPES.KEY_POINTS,
  FACT_TYPES.OUTLINE,
])

export const yes = always(true)
export const no = always(false)

export const doOnlyRequirements = pipe(column('G'), equals('ONLY'))
export const notOnlyRequirements = complement(doOnlyRequirements)
